import { JSX } from 'react';
import './styles/workflow.scss';
import WorkflowContextProvider from "./context/WorkflowContextProvider";
import {
    useRecordContext,
    useGetIdentity
} from 'react-admin';
import { WorkflowBuilder } from "./components/WorkflowBuilder";
import { WorkflowControls } from "./components/WorkflowControls";
import { WorkflowNodeCreateEdit } from "./components/forms/WorkflowNodeCreateEdit";
import { WorkflowNodeToolConfigure } from "./components/forms/WorkflowNodeToolConfigure";
import { WorkflowIfNodeConfigure } from "./components/forms/WorkflowIfNodeConfigure";
import { WorkflowScraperNodeConfiguration } from "./components/forms/WorkflowScraperNodeConfiguration";
import { WorkflowSitemapNodeConfiguration } from "./components/forms/WorkflowSitemapNodeConfiguration";
import { WorkflowHQFetchNodeConfiguration } from "./components/forms/WorkflowHQFetchNodeConfiguration";
import { WorkflowHTTPNodeConfiguration } from "./components/forms/WorkflowHTTPNodeConfiguration";
import { WorkflowMergeNodeConfiguration } from "./components/forms/WorkflowMergeNodeConfiguration";
import { WorkflowParallelNodeConfiguration } from "./components/forms/WorkflowParallelNodeConfiguration";
import { WorkflowLoopNodeConfiguration } from "./components/forms/WorkflowLoopNodeConfiguration";
import { WorkflowSwitchNodeConfiguration } from "./components/forms/WorkflowSwitchNodeConfiguration";
import { WorkflowHQUpdateNodeConfiguration } from "./components/forms/WorkflowHQUpdateNodeConfiguration";
import { WorkflowHQCreateNodeConfiguration } from "./components/forms/WorkflowHQCreateNodeConfiguration";
import { WorkflowSummarizeNodeConfiguration } from "./components/forms/WorkflowSummarizeNodeConfiguration";
import { WorkflowConvertNodeConfiguration } from "./components/forms/WorkflowConvertNodeConfiguration";
import { WorkflowFilterNodeConfiguration } from "./components/forms/WorkflowFilterNodeConfiguration";
import { WorkflowMoveNodeConfiguration } from "./components/forms/WorkflowMoveNodeConfiguration";
import { WorkflowExtractionNodeConfiguration } from "./components/forms/WorkflowExtractionNodeConfiguration";
import { WorkflowInjectionNodeConfiguration } from "./components/forms/WorkflowInjectionNodeConfiguration";
import { WorkflowDataResetNodeConfiguration } from "./components/forms/WorkflowDataResetNodeConfiguration";
import { WorkflowSortNodeConfiguration } from "./components/forms/WorkflowSortNodeConfiguration";
import { WorkflowSampleDataNodeConfiguration } from "./components/forms/WorkflowSampleDataNodeConfiguration";
import { WorkflowHumanNodeConfiguration } from "./components/forms/WorkflowHumanNodeConfiguration";
import { WorkflowExecutionConfiguration } from "./components/forms/WorkflowExecutionConfiguration";
import { WorkflowUiUpdateConfiguration } from "./components/forms/WorkflowUiUpdateConfiguration";

import {  useFormContext } from "react-hook-form"
import {
    ReactFlowProvider,
} from '@xyflow/react';
import { NodeTestOutputModal } from "./components/components/testing/components/NodeTestOutputModal";
import { Workflow } from "../../types/entities";

export const WorkflowContainer: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const record: Workflow = useRecordContext();
    const { setValue } = useFormContext();
    const { data, isPending, error } = useGetIdentity();
    return (
        <div className="workflow-container">
            <div className="workflow-content">
                <WorkflowContextProvider
                    record={ record }
                    mode={ props.mode }
                    setFormValue={ setValue }
                    adminUsername={ data.fullName ?? undefined }
                >
                    <ReactFlowProvider
                        initialWidth={2500}
                        initialHeight={2500}
                    >
                        <WorkflowBuilder />
                        <WorkflowNodeCreateEdit />
                        <WorkflowNodeToolConfigure />
                        <WorkflowIfNodeConfigure />
                        <WorkflowScraperNodeConfiguration />
                        <WorkflowSitemapNodeConfiguration />
                        <WorkflowHQFetchNodeConfiguration />
                        <WorkflowHTTPNodeConfiguration />
                        <WorkflowMergeNodeConfiguration />
                        <WorkflowParallelNodeConfiguration />
                        <WorkflowLoopNodeConfiguration />
                        <WorkflowSwitchNodeConfiguration />
                        <WorkflowHQUpdateNodeConfiguration />
                        <WorkflowHQCreateNodeConfiguration />
                        <WorkflowSummarizeNodeConfiguration />
                        <WorkflowConvertNodeConfiguration />
                        <WorkflowFilterNodeConfiguration />
                        <WorkflowMoveNodeConfiguration />
                        <WorkflowExtractionNodeConfiguration />
                        <WorkflowInjectionNodeConfiguration />
                        <WorkflowDataResetNodeConfiguration />
                        <WorkflowSortNodeConfiguration />
                        <WorkflowSampleDataNodeConfiguration />
                        <WorkflowHumanNodeConfiguration />
                        <NodeTestOutputModal />
                        <WorkflowUiUpdateConfiguration />
                    </ReactFlowProvider>
                    <WorkflowControls />
                    <WorkflowExecutionConfiguration />
                </WorkflowContextProvider>
            </div>
        </div>
    );
}